export default "__VITE_ASSET__BwU9Ufzs__"